var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIconCallout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-626.000000, -203.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(511.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-icon-callout",
    transform: "translate(115.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 10,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    x: 0,
    y: 0,
    width: 1,
    height: 14,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    x: 15,
    y: 0,
    width: 1,
    height: 14,
    rx: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIconCallout);
export default __webpack_public_path__ + "static/media/icon-icon-callout.06d4095f7526802c41ad64a5b24caec6.svg";
export { ForwardRef as ReactComponent };